import React from 'react';
import moment from 'moment-timezone';
import 'moment/min/locales';

export class EventInfo extends React.Component {
  render () {
    return (
      <div className="event-info">
        { (this.props.tags?.length || 0 > 0) && (
          <div className="event-info__tags">
            { this.props.tags && this.props.tags.map(tag => <div>{ tag.name }</div>) }
          </div>
        )}

        { this.props.eventSchedule && this.props.eventSchedule.map(schedule => (
          <EventInfoSchedule {...schedule} />
        ))}
      </div>
    );
  }
}

class EventInfoSchedule extends React.Component {
  render () {
    moment.locale(this.props.language);

    return (
      <div className="event-info__block">
        { this.props.location && <div className="event-info__row event-info__block__venue">— { this.props.location.name }</div> }

        { this.props.schedule && (<div className="event-info__row">
          <div>Programme</div>
          <div>
            { this.props.schedule && this.props.schedule.map(event => {
              if (event.type === 'range') return (
                <div>
                  { moment(event.startDate).format('DD.MM.YYYY') } - { moment(event.endDate).format('DD.MM.YYYY') }
                </div>
              )
              if (event.type === 'performance') return (
                <div>
                  { moment(event.startDate).format('DD.MM.YYYY') } - { moment(event.startDate).format('HH:mm') }
                  { event.endDate && <>&nbsp;- {moment(event.endDate).format('HH:mm')}</> }
                </div>
              )
            })}
          </div>
        </div>)
        }
        
        { this.props.ticketLink &&
          <div className="event-info__row">
            <div>Tickets</div>
            <div className="event-info__link">
              <a href={this.props.ticketLink} target="_blank">{this.props.ticketLink}</a>
            </div>
          </div>
        }

        { (this.props.location && this.props.location.address) &&
          <div className="event-info__row">
            <div>Address</div>
            <div>{ this.props.location.address }</div>
          </div>
        }

        { this.props.organisation &&
          <div className="event-info__row">
            <div>Organisation</div>
            <div>{this.props.organisation}</div>
          </div>
        }
          
        { this.props.moreInfo &&
          <div className="event-info__row">
            <div>More Info</div>
            <div className="event-info__link">
              <a href={this.props.moreInfo} target="_blank">{this.props.moreInfo}</a>
            </div>
          </div>
        }
      </div>
    )
  }
}
